import axios, {} from 'axios'
import {mPrint} from "../mPrint";
import MD5 from "crypto-js/md5";
import {BridgeHelper} from "../bridgeHelper";
import {HttpErrorTool} from "../errorHandler";

let APIMap = new Map();

const onRequestFinished = (apiHash, api, param, statusCode, errMsg) => {
    let obj = APIMap.get(apiHash);
    let additionalInfo;
    if (obj && obj.beginDate) {
        let endDate = new Date();
        additionalInfo = {duration: (endDate.getTime() - obj.beginDate.getTime())};
    }

    BridgeHelper.grayLogNetwork(api, JSON.stringify(param), statusCode, errMsg, additionalInfo);
    APIMap.delete(apiHash);
};

const HttpTool = {
    post(baseUrl, api, param, success, fail) {
        axios.defaults.baseURL = baseUrl
        axios.defaults.headers.common = {'Authorization': `Bearer ${window.passProps?.accessToken || ''}`}
        axios.defaults.withCredentials = true
        axios.defaults.timeout = 60000
        mPrint(`${api}\n param =>`, param);

        let apiHash = this.getAPIHash(api, param);

        axios.post(api, param)
            .then(response => {
                mPrint(`${api}\n response =>`, response);
                success && success(response.data);
                onRequestFinished(apiHash, api, param, response.status);
            })
            .catch(error => {
                mPrint(`${api}\n error =>`, error?.response || error);

                if (error && error.toString().indexOf('401') !== -1) {
                    BridgeHelper.refreshToken((accessToken) =>{
                        window.passProps.accessToken = accessToken
                    })
                }

                let cusError = HttpErrorTool.processError(error);

                fail && fail(cusError?.error || error);

                onRequestFinished(apiHash, api, param, cusError?.code || 0, cusError?.error ? JSON.stringify(cusError?.error) : error?.message);
            });

        APIMap.set(apiHash, {beginDate: (new Date())});

        return apiHash
    },
    getAPIHash(api, param) {
        let str = api + JSON.stringify(param) + (new Date()).getTime();
        return MD5(str).toString()
    }
}

export default HttpTool

